import firebase from 'firebase'
import { authApp } from '~/services/firebase'

export async function logoutExt(SET_CURRENT_USER, SET_TOKEN) {
  console.log('Inside logoutExt() - SET_CURRENT_USER, SET_TOKEN', SET_CURRENT_USER, SET_TOKEN)
  window.localStorage.clear()
  SET_CURRENT_USER(null)
  SET_TOKEN('')
  await firebase.auth(authApp).signOut()
  window.location.replace('/')
}
